import { CreateAlert } from '../../../shared/common-alerts/SKAlerts';

export const validateProductHomePageSection = (payload, setAlert) => {
  if (!payload.SectionName?.trim()) {
    CreateAlert('Please enter section name!!', 'Warning', setAlert);
    return false;
  }
  return true;
};
